module.exports = __webpack_public_path__ + "img/OM.f837b184.png";